import React from 'react';
import './Map.css';

function Map() {
  // Using Google Maps embed (no API key required)
  // For Giarmata, Timiș, Romania
  // Coordinates: 45.841163, 21.318518
  // You can get the embed URL from Google Maps by: Right-click on map > Share or embed map > Embed a map > Copy HTML
  const lat = 45.841163;
  const lng = 21.318518;
  const mapEmbedUrl = `https://www.google.com/maps?q=${lat},${lng}&z=15&output=embed`;

  return (
    <div className="map-section scroll-fade-in">
      <div className="map-container">
        <div className="map-wrapper">
          <iframe
            className="map-iframe"
            src={mapEmbedUrl}
            width="100%"
            height="100%"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            title="MythLabs Location - Giarmata Strada Viilor 63"
          ></iframe>
        </div>
        <div className="map-info">
          <h3>Find Us</h3>
          <p>Giarmata Strada Viilor 63</p>
          <p>Giarmata, Timiș, Romania</p>
        </div>
      </div>
    </div>
  );
}

export default Map;

